import { AutogenLayoutRenditionFilterProfiles } from "./autogen/AutogenLayoutRenditionFilterProfiles";

export class RenditionFilterProfiles extends AutogenLayoutRenditionFilterProfiles {

    private prevVariable;
    private prevOperator;
    private timer: any;
    private scnt = 0;

    override onLoad() {
        //console.log(this);
        clearInterval(this.timer);
        this.timer = setInterval(() => this.GetNewFilterId(), 250);
    }

/** This is an event handler for the onChange event of tbVariables. */
  tbVariablesOnChange(event) {
    if( this.tbVariables.text != this.prevVariable )
    {
        this.textboxFiltExprsn.text += this.tbVariables.text;
        this.prevVariable = this.tbVariables.text;
    }
}

/** This is an event handler for the onChange event of tbOperators. */
  tbOperatorsOnChange(event) {
    if( this.tbOperators.text != this.prevOperator )
    {
        this.textboxFiltExprsn.text += this.tbOperators.text;
        this.prevOperator = this.tbOperators.text;
    }
  }

  async GetNewFilterId()
  {
    clearInterval(this.timer);
    this.timer = null;
    let fid=0, pfid=0;
    if( this.sourceRenditionFilterProfiles.mode == "add" )
    {   //Adding a new record
        await this.sourceRenditionFilterProfs.search( { filt_id: ">0" } );
        for( let i=0; i < this.sourceRenditionFilterProfs.rowCount; i++ )
        {
            this.sourceRenditionFilterProfs.rowIndex = i;
            fid = this.sourceRenditionFilterProfs.activeRow.data.filt_id;
            if( fid > pfid )
                pfid = fid;
        }
    }
    if( pfid > 0 )
    {
        pfid += 1;
        this.textboxFiltId.text = pfid.toString();
        this.textboxFiltId.enabled = false;
    }
  }
}
